import actionTypes from './actionTypes';

export const loginRequest = () => ({
    type: actionTypes.LOGIN_REQUEST
});

export const loginSuccess = (payload) => ({
    type: actionTypes.LOGIN_SUCCESS,
    payload
});

export const loginError = (payload) => ({
    type: actionTypes.LOGIN_FAILURE,
    payload
});

export const logoutRequest = () => ({
    type: actionTypes.CLEAR_STATE
});

export const setTenant = (tenant) => ({
    type: actionTypes.SET_TENANT,
    payload: tenant
});

export const getTenant = () => ({
    type: actionTypes.GET_TENANT
});

export const setAccessType = (accessType) => ({
    type: actionTypes.SET_ACCESS_TYPE,
    payload: accessType
});

export const setUserDetails = (user) => ({
    type: actionTypes.SET_USER_DETAILS,
    payload: user
});

export const updateUserState = () => ({
    type: actionTypes.UPDATE_USER_STATE
});

// export const getAccessType = () => ({
//     type: actionTypes.GET_ACCESS_TYPE
// });
